import { render, staticRenderFns } from "./Modelos.vue?vue&type=template&id=8c834508&scoped=true"
import script from "./Modelos.vue?vue&type=script&lang=js"
export * from "./Modelos.vue?vue&type=script&lang=js"
import style0 from "./Modelos.vue?vue&type=style&index=0&id=8c834508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c834508",
  null
  
)

export default component.exports